import { render, staticRenderFns } from "./project-home-header-options.vue?vue&type=template&id=7965fac6&"
import script from "./project-home-header-options.vue?vue&type=script&lang=ts&"
export * from "./project-home-header-options.vue?vue&type=script&lang=ts&"
import style0 from "./project-home-header-options.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports